define(function(require) {
    //var config =require("./config.js");
    var baseUrl =require("../utils/baseUrl");
    var erpplatfileserver=baseUrl.erpplatfileserver;
    var spreadNS = GC.Spread.Sheets;
    var  spread =null;
    var  excelIO_spd = GC.Spread.Excel.IO();
    var  excelIO =null;
    var rptJson = {};
    var sheetjson={};


    var  spreadView= {

        setWorkBook: function(obj) {
            this.spread= new spreadNS.Workbook(obj[0]);

              return this.spread;
        },


        getRptData: function (param) {
            //请求地址
            var _this = this;
            var dataSource = erpplatfileserver+"/reportForm/getFormJsonData";

            return Promise.resolve(this.getDataForUrl(dataSource,param));
        },
        getRptObj: function (param) {
            //请求地址
            var _this = this;
            var dataSource = erpplatfileserver+"/reportForm/download";

            return Promise.resolve(this.getDataForUrl(dataSource,param));
        },
        getRptList: function (param) {
            //请求地址
            var _this = this;
            var dataSource = reportserver+"/report/getReportList";

            return Promise.resolve(this.getDataForUrl(dataSource,param));
        },


        getDataForUrl: async function (url,param) {

            var new_params = {};
            new_params.name = "";
            new_params.token = sessionStorage.getItem("token");
            new_params.i_uid = sessionStorage.getItem("userid");
            new_params.app = "jxcweb";
            new_params.version = "1.0";
            new_params.company_id=0;
            new_params.pageNum=0;
            new_params.pageRows=50;
            $.each(param, function (key, item) {
                new_params[key]=item;
            });
            let config = {
                credentials: 'include',
                method: 'post',
            };
            config.body = json ? JSON.stringify(new_params) : JSON_stringify(new_params);
            config.headers = {
                'content-type': "application/json",
            };

            function json(response) {
            }

            return fetch(url, config).then(res => res.json());

        }


    };


    return spreadView;
});
